import type { MigrationSummaryCounts, PlanFormState } from './types';

export type ClearErrorAction = { type: 'CLEAR_ERROR' };
export const clearError = (): ClearErrorAction => ({ type: 'CLEAR_ERROR' });

export type SetErrorAction = { type: 'SET_ERROR'; error: string };
export const setError = (error: string): SetErrorAction => ({ type: 'SET_ERROR', error });

export type SelectUserAction = { type: 'SELECT_USER'; userId: string };
export const selectUser = (userId: string): SelectUserAction => ({ type: 'SELECT_USER', userId });

export type ClearSelectedUserAction = { type: 'CLEAR_SELECTED_USER' };
export const clearSelectedUser = (): ClearSelectedUserAction => ({ type: 'CLEAR_SELECTED_USER' });

export type SetUserSearchValueAction = { type: 'SET_USER_SEARCH_VALUE'; value: string };
export const setUserSearchValue = (value: string): SetUserSearchValueAction => ({
    type: 'SET_USER_SEARCH_VALUE',
    value,
});

export type SetSelectedUserLabelAction = { type: 'SET_SELECTED_USER_LABEL'; label: string | null };
export const setSelectedUserLabel = (label: string | null): SetSelectedUserLabelAction => ({
    type: 'SET_SELECTED_USER_LABEL',
    label,
});

export type StartEditingPlanAction = { type: 'START_EDITING_PLAN'; planId: string; formState: PlanFormState };
export const startEditingPlan = (planId: string, formState: PlanFormState): StartEditingPlanAction => ({
    type: 'START_EDITING_PLAN',
    planId,
    formState,
});

export type StopEditingPlanAction = { type: 'STOP_EDITING_PLAN' };
export const stopEditingPlan = (): StopEditingPlanAction => ({ type: 'STOP_EDITING_PLAN' });

export type UpdatePlanFormFieldAction = {
    type: 'UPDATE_PLAN_FORM_FIELD';
    key: keyof PlanFormState;
    value: PlanFormState[keyof PlanFormState];
};
export const updatePlanFormField = (
    key: keyof PlanFormState,
    value: PlanFormState[keyof PlanFormState],
): UpdatePlanFormFieldAction => ({
    type: 'UPDATE_PLAN_FORM_FIELD',
    key,
    value,
});

export type SetPlanSavingAction = { type: 'SET_PLAN_SAVING'; saving: boolean };
export const setPlanSaving = (saving: boolean): SetPlanSavingAction => ({ type: 'SET_PLAN_SAVING', saving });

export type StartCreatingPlanAction = { type: 'START_CREATING_PLAN'; formState: PlanFormState };
export const startCreatingPlan = (formState: PlanFormState): StartCreatingPlanAction => ({
    type: 'START_CREATING_PLAN',
    formState,
});

export type SetMigrationSummaryAction = {
    type: 'SET_MIGRATION_SUMMARY';
    summary: MigrationSummaryCounts | null;
};
export const setMigrationSummary = (summary: MigrationSummaryCounts | null): SetMigrationSummaryAction => ({
    type: 'SET_MIGRATION_SUMMARY',
    summary,
});

export type SubscriptionAdminAction =
    | ClearErrorAction
    | SetErrorAction
    | SelectUserAction
    | ClearSelectedUserAction
    | SetUserSearchValueAction
    | SetSelectedUserLabelAction
    | StartEditingPlanAction
    | StopEditingPlanAction
    | UpdatePlanFormFieldAction
    | SetPlanSavingAction
    | StartCreatingPlanAction
    | SetMigrationSummaryAction;
